import { GetByIdArgsInterface } from '../base/getByIdArgs.interface'
import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class BaseGetByIdArgs<T> implements GetByIdArgsInterface {
  @Field(t => Int)
  id!: number

  @Field(t => Int, { nullable: true })
  forUserId?: number

  @Field(t => [Int], { nullable: true })
  ids?: number[]

  @Field(t => Boolean, { nullable: true })
  genericSearch?: boolean

  public constructor (partial?: Partial<T>) {
    Object.assign(this, partial)
  }
}
